import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

export function hasMeaningfulTotalSupply(dashboard) {
  const supply = Number(dashboard?.totalSupply);
  return Number.isFinite(supply) && supply > 0;
}

export function formatProtocolReserves(value) {
  const num = Number(value);
  if (!Number.isFinite(num)) {
    return null;
  }

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(num);
}

export function formatReservesBackingRatio(value) {
  const num = Number(value);
  if (!Number.isFinite(num)) {
    return null;
  }

  // Decimal ratio (e.g. 1.05) vs raw percent scale (e.g. 4006).
  const percent = num <= 10 ? num * 100 : num;
  const formatted = percent.toFixed(2);

  if (formatted.endsWith(".00")) {
    return `${Math.round(percent)}%`;
  }

  return `${formatted}%`;
}

export function formatLastVerifiedParts(timestamp) {
  const ms = Number(timestamp);
  if (!Number.isFinite(ms)) {
    return null;
  }

  const date = dayjs(ms).utc();

  return {
    time: date.format("HH:mm:ss"),
    date: date.format("YYYY.MM.DD"),
  };
}

export function formatHeroReservesSum(total) {
  const num = Number(total);
  if (!Number.isFinite(num)) {
    return null;
  }

  const millions = num / 1_000_000;
  return `$${millions.toFixed(1)}M`;
}
